export enum DescType {
  DESCPRODUCTDETAILS = 'DESCPRODUCTDETAILS',
}
